var i = 0;

var generateId = function generateId(prefix) {
  var randomId = (Math.random() * 100000).toString(32).replace('.', '') + i++;
  return "".concat(prefix, "-").concat(randomId);
};

export default generateId;